<template>
    <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="white"
    dark
    flat
    >
        <v-btn icon to="/properties">
          <v-icon color="primary">mdi-apps</v-icon>
        </v-btn>
        <v-btn icon to="/calendar">
          <v-icon color="primary">mdi-calendar</v-icon>
        </v-btn>
        <v-btn icon to="/tasks">
          <v-icon color="primary">mdi-check-decagram</v-icon>
        </v-btn>
        <v-btn icon to="/users">
          <v-icon color="primary">mdi-account-multiple</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-img
            class="top-logo"
            max-width="100"
            :src="logo"
            alt="Commercial Properties"
        ></v-img>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="profileToggle = !profileToggle">
          <v-icon color="primary">mdi-account-cog-outline</v-icon>
        </v-btn>
        <v-btn icon @click="hasHistory() ? $router.go(-1) : $router.push('/')" v-if="back">
          <v-icon color="primary">mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn icon @click.prevent="signOut">
            <v-icon color="primary">mdi-logout</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import logo from "@/assets/logo.png"

export default {
    data: () => ({
        back: false,
        logo: logo,
    }),
    computed: {
        ...mapGetters({
            profile: 'menu/profileDialog'
        }),
        menuToggle: {
            get() {
                return this.$store.state.menu.show_menu
            },
            set(newValue) {
                this.$store.commit('SET_MENU', newValue)
            }
        },
        profileToggle: {
            get() {
                return this.profile
            },
            set(newValue) {
                this.$store.commit('menu/SET_PROFILE_DIALOG', newValue)
            }
        },
    },
    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut'
        }),
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'Home'
                })
            })
        },
        hasHistory () { 
            return window.history.length > 2 
        },
    },
    mounted() {
        if(this.$route.name != 'Dashboard') {
            this.back = true
        }
    },
    watch:{
        $route (to){
            if(to.name == 'Dashboard') {
                this.back = false
            } else {
                this.back = true
            }
        }
    } 
}
</script>

<style lang="sass" scoped>
.top-logo
    position: absolute
    left: 50%
    margin-left: -50px
</style>